// Line map API helpers. The legacy Vue 2 implementation used
// `$.post('/line_map/getGpxes', { id })` (the route is POST-only) and
// `$.ajax('/kml...')`. These wrappers use `fetch` with the shared same-origin /
// CSRF handling from `../api`.
//
// Each helper accepts an optional `AbortSignal` so the app can abort in-flight
// requests on teardown (the legacy code called `ajax.abort()` on
// `turbo:before-visit`).

import { postForm } from '../api'

export function getGpxes(userId, signal) {
  return postForm('/line_map/getGpxes', { id: userId }, signal)
}

// `collabo_line_map#show` (the shared/collection map). Same POST-only shape as
// `line_map` but a different endpoint, and the id is the `Collabo` id.
export function getCollaboGpxes(collaboId, signal) {
  return postForm('/collabo_line_map/getGpxes', { id: collaboId }, signal)
}

export function fetchGpxDownload(url, signal) {
  return fetch(url, {
    credentials: 'same-origin',
    signal,
    headers: {
      Accept: '*/*',
      'X-Requested-With': 'XMLHttpRequest',
    },
  }).then(function (response) {
    if (!response.ok) {
      throw new Error(`Request GET ${url} failed with status ${response.status}`)
    }
    return response.text()
  })
}
